import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/auth/Login'
import ResetPassword from '../views/auth/passwords/Reset'
import Email from '../views/auth/passwords/Email'
import User from '../views/app/User'
import Dashboard from '../views/app/Dashboard'
import Invoices from '../views/app/Invoices'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem('auth')) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/password/reset/:token',
      name: 'reset',
      component: ResetPassword,
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem('auth')) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/password/email',
      name: 'email',
      component: Email,
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem('auth')) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/user/',
      name: 'user',
      component: User
    },
    {
      path: '/invoices/',
      name: 'invoices',
      component: Invoices
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

export default router
